import React, { useEffect, useRef } from "react";

interface IvideonPlayerProps {
  cameraId: string;
  cameraName: string;
  apiHost: string;
  accessToken: string;
  setPlayer: any;
}

const options = {
  availableLanguages: ["ru"],
  language: "ru",
};

const IvideonPlayer: React.FC<IvideonPlayerProps> = ({
  accessToken,
  apiHost,
  cameraId,
  setPlayer,
}) => {
  const ivideonRef = useRef(null);

  useEffect(() => {
    if (ivideonRef.current) {
      window[`_ivideon`].sdk
        .init({
          rootUrl: "/ivideon/",
          l10nOptions: options,
          debug: true,
        })
        .then((sdk) => {
          sdk.configureWithCloudApiAuthResponse({
            api_host: apiHost,
            access_token: accessToken,
          });
          let camera = sdk.createCamera({
            id: cameraId,
            cameraName: "Demo Cam",
            imageWidth: 600,
            imageHeight: 350,
            soundEnabled: false,
          });
          let player = sdk.createPlayer({
            container: ".myapp-player-container",
            camera: camera,
            sizeCalculationMethod: sdk.playerSize.FILL_BY_WIDTH,
            layout: "auto",
            fullscreenEnabled: true,
            previewEnabled: false,
            previewFromCameraEnabled: false,
            timelineEnabled: true,
            rewindEnabled: false,
            timelineHighlightRecordsEnabled: true,
            timelineHighlightRecordsLegendEnabled: true,
            hotkeysEnabled: false,
            zoomEnabled: true,
          });
          player.playLive();
          setPlayer(player);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [ivideonRef, cameraId, accessToken, apiHost]);

  return <div ref={ivideonRef} className="myapp-player-container"></div>;
};

export default IvideonPlayer;
